import React from "react";
import { COLORS } from "./tokens";

/**
 * PILLAR SYMBOL — tiny flower + leaf + gold stem.
 * Meaning: Faith • Strength • Hope. Placed under the brand name.
 */
const PillarSymbol = React.forwardRef(function PillarSymbol(
  { size = 120, id = "rona-pillar-symbol" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 200"
      width={size}
      height={(size * 200) / 160}
      role="img"
      aria-label="Faith Strength Hope pillar symbol"
    >
      {/* Stem (gold) */}
      <path
        d="M80 190 C 80 150, 80 110, 80 70"
        stroke={COLORS.gold}
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />

      {/* Leaf on the left (sage green) */}
      <path
        d="M80 130
           C 62 124, 48 130, 44 144
           C 56 150, 72 146, 80 136 Z"
        fill={COLORS.sage}
      />
      {/* leaf vein */}
      <path
        d="M80 136 L 48 142"
        stroke={COLORS.creamSoft}
        strokeOpacity="0.7"
        strokeWidth="0.9"
        fill="none"
      />

      {/* Flower (dusty blue) — 5 simple petals */}
      <g fill={COLORS.dustyBlue}>
        <ellipse cx="80" cy="48" rx="10" ry="16" />
        <ellipse cx="80" cy="48" rx="10" ry="16" transform="rotate(72 80 48)" />
        <ellipse cx="80" cy="48" rx="10" ry="16" transform="rotate(144 80 48)" />
        <ellipse cx="80" cy="48" rx="10" ry="16" transform="rotate(216 80 48)" />
        <ellipse cx="80" cy="48" rx="10" ry="16" transform="rotate(288 80 48)" />
      </g>
      <circle cx="80" cy="48" r="5" fill={COLORS.gold} />
    </svg>
  );
});

export default PillarSymbol;
